
import { defineComponent, ref, watch, onMounted } from 'vue';
import SelectSeat from '@/components/Service/Seat/SelectSeat.vue';
import { Order } from '@/utils/api/order';
import { ElMessage } from 'element-plus';
import router from '@/router/index';

export default defineComponent({
  name: 'SeatSelection',
  components: { SelectSeat },
  setup() {
    //表单数据验证
    const formData = ref({
      id: router.currentRoute.value.query.orderId as string,
    });
    onMounted(() => {
      if (formData.value.id !== undefined && formData.value.id.length > 0) {
        onSubmit();
      }
    });
    const rules = {
      id: [{ required: true, message: '请输入订单号' }],
    };
    const form = ref(null);
    const onSubmit = () => {
      console.log(seats.value);
      console.log(seats.value.length);
      (form.value as any).validate((valid: boolean) => {
        if (valid) {
          Order.getPassengers({
            orderId: formData.value.id,
          })
            .then((res) => {
              if (res.status === 200) {
                console.log('res.data: ', res.data);
                // for (let i = 0; i < res.data.numOfC; i++) {
                //   customers.value.push(res.data.customer);
                // }
                customers.value = res.data.customers;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log('error submit!!');
        }
      });
    };

    const seats = ref([]);
    const customers = ref([
      {
        name: '_____',
        id: '__________',
        seat: '_____',
      },
    ]);
    watch(
      () => seats.value.length,
      () => {
        let sl = seats.value.length;
        let cl = customers.value.length;
        for (let i = 0; i < cl; i++) {
          if (i >= sl) {
            customers.value[i].seat = '';
          } else {
            customers.value[i].seat = seats.value[i];
          }
        }
      }
    );
    const confirm = () => {
      //提交座位数据
      Order.selectSeat({
        orderId: formData.value.id,
        seats: seats.value,
      })
        .then((res) => {
          if (res.status === 200) {
            ElMessage('选座成功');
          } else {
            ElMessage('选座失败');
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
    return {
      formData,
      rules,
      form,
      onSubmit,
      //
      seats,
      customers,
      confirm,
    };
  },
});
